<template>
  <div class="page-section">
    <h1 class="info-title">{{ titleText }} <b>{{ titleBoldText }}</b></h1>
    <h1 class="top-title">
      <span>£</span
      >{{ numberToHumanReadable(monthlyAvgDisposableIncome.total) }}
    </h1>
    <div class="section-subtitle">
      {{ subtitleText }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { numberToHumanReadable } from '../../../../utils/miscUtils';

const props = defineProps({
  monthlyAvgDisposableIncome: {
    type: Object,
    required: true,
  },
  variant: {
    type: String,
    default: 'netBalance',
  },
});
const INFO_TITLE_TEXT = {
  netBalance: 'Your average monthly',
  savingPotential: 'Your average monthly',
};
const INFO_TITLE_BOLD_TEXT = {
  netBalance: 'net balance',
  savingPotential: 'saving potential',
};

const SUBTITLE_TEXT = {
  netBalance: 'Struggling with cash flow?'
    + 'Your spending habits may be hurting your financial health. Explore the potential cutbacks below to help you save more.',
  savingPotential: 'This is the amount you might be able to save monthly, based on your income and spending habits.',
};

const titleText = computed(() => INFO_TITLE_TEXT[props.variant] || INFO_TITLE_TEXT.netBalance);
const titleBoldText = computed(() => INFO_TITLE_BOLD_TEXT[props.variant] || INFO_TITLE_BOLD_TEXT.netBalance);
const subtitleText = computed(() => SUBTITLE_TEXT[props.variant] || SUBTITLE_TEXT.netBalance);
</script>

<style lang="scss" scoped>
@import "../../../../scss/riseup-vars";

.page-section {
  background-color: #fcf7ed;
  color: #202125;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 35px;
}

.info-title {
  font-size: 16px;
  color: #202125;
  padding-top: 40px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.info-title b {
  font-weight: 700;
}

.top-title {
  font-size: 67px;
  color: #202125;
  line-height: 1;
  width: 80%;
  margin-left: 10%;
  text-align: left;
  margin-bottom: 20px;
}

.top-title span {
  font-size: 40px;
}

.section-subtitle {
  font-size: 17px;
  margin-top: 25px;
  margin-bottom: 40px;
  color: #202125;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}
</style>
